'use client';

import { styled } from 'styled-components';

export const ScIconComponent = styled.i<{ $size?: string; $margin?: string }>`
  && {
    font-family: var(--font-icons);
    font-size: ${({ $size }) => $size || '24px'};
    line-height: 100%;
    font-display: block;
  }
`;
